module.exports = __webpack_public_path__ + "static/img/download-coin-bg.2f97c59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-coin-bg.jpg
// module id = 859
// module chunks = 12